// src/Components/Resume.js
import React, { Component } from "react";
import Slide from "react-reveal";

class Resume extends Component {
  render() {
    if (!this.props.data) return null;

    const education = this.props.data.education.map((education) => (
      <div key={education.school} className="resume-block">
        <h3>{education.school}</h3>
        <p className="info">
          {education.degree} <span>&bull;</span>
          <em className="date">{education.graduated}</em>
        </p>
        <p>{education.description}</p>
      </div>
    ));

    const work = this.props.data.work.map((work) => (
      <div key={work.company} className="resume-block">
        <h3>{work.company}</h3>
        <p className="info">
          {work.title} <span>&bull;</span>
          <em className="date">{work.years}</em>
        </p>
        <p>{work.description}</p>
      </div>
    ));

    const skills = this.props.data.skills.map((skill) => {
      const width = skill.level;
      return (
        <li key={skill.name}>
          <span style={{ width }} className="bar-expand" />
          <em>{skill.name}</em>
        </li>
      );
    });

    return (
      <section id="resume">
        {/* Education from left */}
        <Slide left duration={1300} distance="30px">
          <div className="row education">
            <div className="three columns header-col">
              <h1>
                <span>Education</span>
              </h1>
            </div>

            <div className="nine columns main-col resume-card">
              <div className="row item">
                <div className="twelve columns">{education}</div>
              </div>
            </div>
          </div>
        </Slide>

        {/* Work from right */}
        <Slide right duration={1300} distance="30px">
          <div className="row work">
            <div className="three columns header-col">
              <h1>
                <span>Work</span>
              </h1>
            </div>

            <div className="nine columns main-col resume-card">{work}</div>
          </div>
        </Slide>

        {/* Skills from bottom */}
        <Slide bottom duration={1300} distance="30px">
          <div className="row skill">
            <div className="three columns header-col">
              <h1>
                <span>Skills</span>
              </h1>
            </div>

            <div className="nine columns main-col resume-card">
              <div className="bars">
                <ul className="skills">{skills}</ul>
              </div>
            </div>
          </div>
        </Slide>
      </section>
    );
  }
}

export default Resume;
